<template>
  <Modal
    cancel-variant="filled"
    :close-triggers="['click-outside', 'close-button', 'escape']"
    spacing="medium"
    :tracking="{ action: 'checkout', topicKey: 'restore_plays' }"
    @cancel="emit('cancel')"
    @confirm="emit('confirm')"
  >
    <template #headline>
      <span class="flex text-left">{{ $t('editor.restoreplays.modal.headline') }}</span>
    </template>

    <template #confirm>{{ $t('editor.restoreplays.modal.confirm') }}</template>

    <template #cancel>{{ $t('editor.restoreplays.modal.cancel') }}</template>

    <p class="paragraph-regular text-left w-full">
      {{ $t('editor.restoreplays.modal.message') }}
    </p>

    <Illustration class="mt-200" name="saved-playslips" />
  </Modal>
</template>

<script lang="ts" setup>
type Emits = {
  (e: 'cancel' | 'confirm'): void
}

const emit = defineEmits<Emits>()
</script>
